import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { ProjectCard } from "@/components/Cards";
import SectionHeader from "@/components/SectionHeader";
import PageSEO from "@/components/PageSEO";

const SECTIONS = ["Property Development", "Land Opportunities", "Real Estate Partnerships", "Selected Projects"];

export default function RealEstate() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { http.get("/projects?sector=real_estate").then(r => setProjects(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageSEO
        title="Real Estate Investment Opportunities in Nigeria"
        description="Mayoto Real Estate — structured land, property development and partnership opportunities in growth corridors of Nigeria. Minimum investment from NGN 5,000, projected 20% p.a. capital appreciation."
        canonicalPath="/real-estate"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">REAL ESTATE</p>
            <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128]" data-testid="real-estate-title">Real Estate Investment Opportunities.</h1>
            <p className="mt-5 text-slate-600 max-w-xl leading-relaxed">
              Mayoto explores carefully selected opportunities within the real estate sector, including property development, land-related projects, and other ventures with long-term value potential.
            </p>
          </div>
          <div className="rounded-3xl overflow-hidden aspect-[4/3]">
            <img src="https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhZnJpY2FuJTIwcmVhbCUyMGVzdGF0ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODU1Mzk4NDJ8MA&ixlib=rb-4.1.0&q=85" alt="Real Estate" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide">
          <div className="flex flex-wrap gap-3 mb-10">
            {SECTIONS.map(s => (
              <span key={s} className="text-xs font-display font-bold tracking-widest text-[#0a1128] bg-white border border-slate-200 rounded-full px-4 py-2">{s.toUpperCase()}</span>
            ))}
          </div>
          <SectionHeader eyebrow="SELECTED PROJECTS" title="Live real estate projects." />
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map(p => <ProjectCard key={p.id} p={p} />)}
            {projects.length === 0 && <div className="text-slate-500">No projects yet. Please check back soon.</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
